import(/* webpackMode: "eager" */ "/codebuild/output/src2340012390/src/web-app/packages/webapp/app/cw/[subdomain]/(app)/questboard/[moduleId]/[questId]/error.tsx");
